import type { PaymentMethodType } from '@patrianna/shared-patrianna-types/store/PaymentsFlowModule'
import type { ChangeEvent } from 'react'
import { useFormContext } from 'react-hook-form'

import FormSelectField from 'src/components/Form/FormSelectField'

import useSelectPaymentMethodValues from '../hooks/useSelectPaymentMethodValues'
import classes from '../styles.module.scss'

import { FormCardSelect } from './FormCardSelect'

/*
  ATTENTION
  THIS IS A MOCK COMPONENT
  PAYMENT METHOD SELECTOR AND ANYTHING AROUND IT IS HERE JUST FOR DESIGN REQUIRMENTS AND FUTURE FEATURES
  CARD SELECTOR IS THE ONLY WORKING LOGIC
*/

export default function FormPaymentMethodSelectFields() {
  const { setValue, watch } = useFormContext()
  const { paymentMethodValues } = useSelectPaymentMethodValues()

  const handlePaymentMethodChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setValue('selectedPaymentMethod', e.target.value as PaymentMethodType)
    setValue('selectedCardId', '')
  }

  const paymentMethod = watch('selectedPaymentMethod')

  return (
    <>
      <FormSelectField
        onChange={handlePaymentMethodChange}
        className={classes.cardVerificationSelect}
        name='selectedPaymentMethod'
        items={paymentMethodValues}
      />
      {paymentMethod && <FormCardSelect paymentMethod={paymentMethod} />}
    </>
  )
}
